import React, { useEffect, useState } from "react";
import PatientCard from "./PatientCard";
import {
  getLoggedinUser,
  setTempSession,
  clearTempSession,
  getUser,
} from "../../userStore";
import {
  careGiverApi,
  useGetCareGiverQuery,
  useGetCgRequestsQuery,
} from "../../redux/service/careGiver_service.js";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { BtnComponent, parseResponse } from "../../utils/common_lib.js";
import { CaregiverRequests } from "./caregiver_requests.js";
import MainPageDialog from "../../components/mainPageDialog.jsx";
import FullScreenLoader from "../../components/FullScreenLoader/index.js";
import { useAppContext } from "../../AppContext.js";
import { usePusherContext } from "../../components/pusher_context.js";

const PatientList = () => {
  const [openCgRequests, setOpenCgRequests] = useState(false);
  const AppContext = useAppContext();
  const pusherContext = usePusherContext();

  const CaregiverData = getLoggedinUser();
  const { data: patients, isLoading } = useGetCareGiverQuery({
    user_id: CaregiverData?.id,
  });
  const { data: reqList, refetch: loadCgRequests } = useGetCgRequestsQuery({
    user_id: CaregiverData.id,
  });
  const [getCaregiverRights, { isFetching: loadingRights }] =
    careGiverApi.endpoints.getCaregiverRights.useLazyQuery();

  const navigate = useNavigate();

  useEffect(() => {
    if (reqList?.length) {
      setOpenCgRequests(true);
    }
  }, [reqList]);

  useEffect(() => {
    refetchRequests();
  }, [pusherContext?.pusherData.caregiver_added]);

  const refetchRequests = async () => {
    await loadCgRequests();
    if (reqList?.length) {
      setOpenCgRequests(true);
    }
  };

  const selectPatient = (patient) => {
    fetchModuleAccessRights(patient);
  };

  const fetchModuleAccessRights = async (patient) => {
    const res = await getCaregiverRights({
      pid: patient.pid,
      patient_user_id: CaregiverData.id,
    });
    const { data, code } = parseResponse(res);
    let caregiverRights = null;
    let access_right = null;
    if (data && data.caregiver?.caregiver_rights) {
      caregiverRights = data.caregiver?.caregiver_rights;
    }
    if (data && data.caregiver?.access_right) {
      access_right = data.caregiver?.access_right;
    }

    const tempSessionData = {
      ...data?.Patient,
      is_temp: true,
      caregiver_rights: caregiverRights,
      access_right: access_right,
      attending_physician: data?.attending_physician || null,
    };
    AppContext.updateAppData("selectedUser", tempSessionData);
    setTempSession(tempSessionData);
    navigateToHome();
  };

  const selectCaregiver = () => {
    clearTempSession();
    AppContext.updateAppData("selectedUser", CaregiverData);
    navigateToHome();
  };

  const navigateToHome = () => {
    setTimeout(() => {
      navigate("/");
    });
  };

  const checkSelected = (patientId) => {
    const selectedPatient = getUser();
    return selectedPatient?.pid === patientId;
  };

  return (
    <>
      <div className="p-8 ">
        <div className="flex gap-2">
          <h1 className="text-2xl text-start  font-bold">Select Patient</h1>
          <div className="text-right flex-1">
            <BtnComponent
              onClick={() => setOpenCgRequests(true)}
              text={
                <>
                  <span>Pending Requests</span>
                  {reqList?.length ? (
                    <span className="bg-red-500 rounded-full px-1 text-white text-sm ml-1">
                      {reqList?.length}
                    </span>
                  ) : (
                    ""
                  )}
                </>
              }
            />
          </div>
        </div>

        <div class="flex-grow border-t border-gray-400 mt-1 "></div>
        <div className="mt-4 mb-2">
          <h4 className="p2 text-start font-bold text-xl mt-4">Caregiver</h4>
          <div
            class={`grid mt-4 grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-3 ${
              isLoading && "animate-pulse"
            }`}>
            <PatientCard
              selected={checkSelected(CaregiverData?.pid)}
              name={CaregiverData?.fname + " " + CaregiverData?.lname}
              sex={CaregiverData?.sex}
              dob={
                CaregiverData?.dob
                  ? moment(CaregiverData?.dob).format("MM/DD/YYYY")
                  : ""
              }
              provider={CaregiverData?.provider}
              checkSelected={CaregiverData?.pid}
              handleSelected={selectCaregiver}
              id={CaregiverData?.pid}
            />
          </div>
        </div>
        <div class="flex-grow border-t border-gray-400 mt-4 mb-4"></div>
        <div class="bg-white  ">
          <div class="mx-auto ">
            <h4 className="p2 text-start font-bold text-xl mt-4 mb-2">
              Patients
            </h4>
            <div class={` ${isLoading && "animate-pulse flex space-x-4"}`}>
              <svg
                class="animate-spin h-5 w-5 mr-3 ..."
                viewBox="0 0 24 24"></svg>
              <div
                class={`mx-auto max-w-2xl space-y-16 divide-y divide-gray-100 lg:mx-0 lg:max-w-none ${
                  isLoading && "animate-pulse flex space-x-4"
                }`}>
                <div
                  class={`grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-3 ${
                    isLoading && "animate-pulse"
                  }`}>
                  {patients &&
                    patients?.map((patient) => (
                      <PatientCard
                        name={patient?.patient}
                        sex={patient?.patient_sex}
                        dob={
                          patient?.patient_dob
                            ? moment(patient?.patient_dob).format("MM/DD/YYYY")
                            : ""
                        }
                        selected={checkSelected(patient?.pid)}
                        provider={patient?.provider_name}
                        checkSelected={patient?.pid}
                        handleSelected={() => selectPatient(patient)}
                        id={patient?.pid}
                      />
                    ))}
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
      </div>

      {/* dialogs */}
      {(loadingRights || isLoading) && <FullScreenLoader />}

      {openCgRequests && (
        <MainPageDialog
          title="Caregiver Requests"
          modalSize="md"
          footerList={[
            {
              type: "close",
              title: "Close",
              action: () => setOpenCgRequests(false),
            },
          ]}
          onCancelHandler={() => setOpenCgRequests(false)}>
          <CaregiverRequests reqList={reqList} />
        </MainPageDialog>
      )}
    </>
  );
};

export default PatientList;
